import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LocaleLayout from "@/components/LocaleLayout";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import LanguageRedirect from "@/components/LanguageRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/:lang" element={<LocaleLayout />}>
            <Route index element={<HomePage />} />
            <Route path="privatuma-politika" element={<PrivacyPolicyPage />} />
          </Route>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/" element={<LanguageRedirect />} />
          <Route path="/privatuma-politika" element={<LanguageRedirect suffix="/privatuma-politika" />} />
          <Route path="*" element={<LanguageRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
